/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Payment Method
 */
export type CreatePaymentRequestMethod = typeof CreatePaymentRequestMethod[keyof typeof CreatePaymentRequestMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePaymentRequestMethod = {
  card: 'card',
  alipay: 'alipay',
  wechat_pay: 'wechat_pay',
  apple_pay: 'apple_pay',
  google_pay: 'google_pay',
  ALL: 'ALL',
  ONLINE: 'ONLINE',
} as const;
